import React from "react";
import styled from "styled-components";
import { ReactComponent as CloseOutlined } from "../../../../assets/icons/CloseIcon.svg";

interface Props {
  imgName?: string;

  onRemove?: (e?: string) => void;
}
const ImageTextBox: React.FC<Props> = (props) => {
  const { imgName, onRemove } = props;
  return (
    <StyledBoxWrapper>
      {imgName}{" "}
      {onRemove && (
        <Close
          onClick={() => {
            if (onRemove) onRemove();
          }}
        />
      )}
    </StyledBoxWrapper>
  );
};

const StyledBoxWrapper = styled.div`
  padding: 6px 12px;
  gap: 10px;

  height: 30px;
  margin-right: 8px;
  /* Gray/Gray 8 */
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  background: #efefef;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
`;
const Close = styled(CloseOutlined)`
  cursor: pointer;
`;
export default ImageTextBox;
